export enum TagInputLayout {
  VERTICAL,
  HORIZONTAL,
}

export interface ITagInputProps {
  showTitle?: boolean;
  required?: boolean;
  width?: string;
  maxW?: string;
  recommendTags?: any[];
  maxLength?: number;
  layout?: TagInputLayout;
  style?: Record<string, any>;
  initTags?: string[];
}
